import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ConnectedAppModalId } from 'containers/ConnectedApps/components/ConnectedAppsStopModal/ConnectedAppsStopModal'
import { AccountSettingsModalTypes, ClaimsModalTypes } from 'models/Modal'

interface IModalReducer extends IModalAction {
  status?: 'finished' | 'error' | 'loading'
}

interface IModalGetter {
  modal: IModalReducer
}

interface IModalAction {
  modalType?: IModalType;
  isActiveTrap?: boolean;
}

export type IModalType = 'mnt' | 'pdt' | 'auth-print' | 'account-settings-name-address' | 'add-edit-email' | 'medicare-you-handbook' | ClaimsModalTypes | AccountSettingsModalTypes | ConnectedAppModalId | undefined

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    modalType: undefined as IModalType,
    isActiveTrap: false
  },
  reducers: {
    // Modal
    setModal: (state: IModalReducer, action: PayloadAction<IModalAction>) => {
      state.modalType = action.payload.modalType
      if (action.payload.modalType !== undefined) {
        state.isActiveTrap = true
      }
    },
    closeModal: (state: IModalReducer) => {
      state.modalType = undefined
    },
    setActiveTrap: (state: IModalReducer, action: PayloadAction<IModalAction>) => {
      state.isActiveTrap = action.payload.isActiveTrap
    }
  }
})

export const {
  closeModal,
  setModal,
  setActiveTrap
} = modalSlice.actions

// GETTERS
export const getModalType = (state: IModalGetter) => state.modal.modalType
export const getIsActiveTrap = (state: IModalGetter) => state.modal.isActiveTrap

export default modalSlice.reducer
